'use client';
import React from'react';
 import Icon from'@/components/ui/AppIcon';

const WhatsAppFloatingButton: React.FC = () => {
  const handleClick = () => {
    window.open(
      'https://wa.me/243996739468?text=Hello, I would like to inquire about your gold export services.',
      '_blank'
    )
  }

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-8 right-8 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl z-50 hover:scale-125 transition-smooth group animate-pulse-ring hover-glow"
      aria-label="Contact us on WhatsApp"
    >
      <Icon name="ChatBubbleLeftRightIcon" size={28} className="text-white group-hover:scale-110 transition-smooth" />
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-error rounded-full animate-pulse group-hover:scale-125 transition-smooth"></span>
    </button>
  )
}

export default WhatsAppFloatingButton